//// Core Scripts
import "bootstrap";

// Polyfills
import "core-js/stable";

// Vendor Styles 
import "font-awesome/css/font-awesome.min.css";
import "react-toastify/dist/ReactToastify.css";

// Custom Styles
import "../styles/app.scss";

// Initialization
const browserDate = document.getElementById("login-form-slim-browser-date");
if (browserDate) {
  // Used to set the user's time zone when they login.
  (browserDate as HTMLInputElement).value = (new Date()).toString();
}

const m = module;
if (m.hot) {
  m.hot.accept();
}
